export const config = {
  //Demo
  // adminapiUrl: 'https://api.clubinnlife.dci.in/api/V1/AP/',
  // venueapiUrl: 'https://api.clubinnlife.dci.in/api/V1/VP/',
  // ticketVerifyUrl: 'http://localhost:35247/ ',
  //Demo
 
  //Live
  // adminapiUrl: 'https://api.clubinn.life/api/V1/AP/',
  // venueapiUrl: 'https://api.clubinn.life/api/V1/VP/',
  // ticketVerifyUrl: 'https://ticket-verify.clubinn.life/',

   //demo
  adminapiUrl: 'https://clubinn.dci.in/api/V1/AP/',
  venueapiUrl: 'https://clubinn.dci.in/api/V1/VP/',
  ticketVerifyUrl: 'https://ticket-verify.clubinn.dci.in/',


  //local
  // adminapiUrl: 'http://127.0.0.1:8000/api/V1/AP/',
  // venueapiUrl: 'http://127.0.0.1:8000/api/V1/VP/',
  // ticketVerifyUrl: 'http://localhost:40229/',




}